var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPageHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 26,
    viewBox: "0 0 17 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8432 23.8617L13.3735 24.3919L13.9038 23.8617L14.5596 23.2061L15.09 22.6758L14.5596 22.1454L5.40108 12.987L14.5596 3.82847L15.09 3.29807L14.5595 2.76774L13.9038 2.11218L13.3734 1.58198L12.8432 2.11225L2.49896 12.4567L1.96864 12.9871L2.49897 13.5174L12.8432 23.8617Z",
    fill: "#AE8FD6",
    stroke: "#AE8FD6",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPageHome);
export default __webpack_public_path__ + "static/media/Left-PageHome.10489f871a80e304b9930ff88a11f44f.svg";
export { ForwardRef as ReactComponent };